// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"496":"b9febfe26fc6b90d","713":"e58e2ddba3625c46"}[chunkId] + ".js";
};